import axios from 'axios';
import config from '../Config';
import authHeader from './auth-header';

const API_URL = config.API_URL;
const API_VERSION = config.API_VERSION;
const getDieQuotationList = (page, pagesize, search, ordering) => {
  return axios.get(`${API_URL}/api/${API_VERSION}/die-quotation/`, {
    headers: authHeader(),
    params: {
      page: page,
      pagesize: pagesize,
      search: search, // You might want to include search here, if applicable
      ordering: ordering
    },
  });
};

const getArchiveDieQuotationList = (page, pagesize, search, ordering) => {
    return axios.get(API_URL +'/api/'+ API_VERSION + '/die-quotation/archive-list', {headers: authHeader(), params: {
        page: page,
        pagesize: pagesize,
        search: search,
        ordering: ordering
    }});
};

const getDieQuotationById = (id) => {
  return axios.get(`${API_URL}/api/${API_VERSION}/die-quotation/${id}`, {headers: authHeader()});
};
const getViewDieQuotationById = (id) => {
  return axios.get(`${API_URL}/api/${API_VERSION}/die-quotation/${id}`, {
      headers: authHeader(),
  });
};
const editDieQuotation = (id, categoryData) => {
    return axios.patch(
      `${API_URL}/api/${API_VERSION}/die-quotation/${id}/`,
      categoryData, 
      { headers: authHeader() }
    );
  };
const PostDieQuotation = categoryData => {
  return axios.post(
    `${API_URL}/api/${API_VERSION}/die-quotation/`,
    categoryData,
    {
      headers: authHeader(),
    },
  );
};
const deleteDieQuotation = (id) => {
    return axios.post(
        `${API_URL}/api/${API_VERSION}/die-quotation/${id}/archive/`, // Include the die group's ID in the URL
        {},
        { headers: authHeader() } // Authentication header
    );
};
const unArchiveDieQuotation = (id) => {
    return axios.post(
        `${API_URL}/api/${API_VERSION}/die-quotation/${id}/unarchive/`, // Include the die group's ID in the URL
        {}, // Pass an empty object if no data needs to be sent
        { headers: authHeader() } // Authentication header
    );
};

const dieQuotationService = {
  getDieQuotationList,
  getArchiveDieQuotationList,
  getDieQuotationById,
  getViewDieQuotationById,
  PostDieQuotation,
  editDieQuotation,
  deleteDieQuotation,
  unArchiveDieQuotation
};

export default dieQuotationService;
